import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TodayCountsService {
  
  private todayCountsSubject = new BehaviorSubject<{delivery: number, pickup: number, total: number, active_driver_count: number}>({
    delivery: 0,
    pickup: 0,
    total: 0,
    active_driver_count: 0
  });

  public todayCounts$ = this.todayCountsSubject.asObservable();

  constructor() { }

  /**
   * Update today's counts
   */
  updateTodayCounts(delivery: number, pickup: number, active_driver_count: number = 0) {
    const total = delivery + pickup;
    console.log('Updating today counts:', { delivery, pickup, total, active_driver_count });
    this.todayCountsSubject.next({
      delivery,
      pickup,
      total,
      active_driver_count,
    });
  }

  /**
   * Get current today's counts value
   */
  getTodayCountsSnapshot() {
    return this.todayCountsSubject.value;
  }
}
